import './InlineEdit.scss';

import { DataTypes, SchemaProperty, UOMS, UomTypes } from '@amzn/awscat-portfolio-assessment-types';
import React from 'react';

import { constants } from '../../../common/Localization';
import { uomConversion } from '../../../common/uomConversion';
import TableCell from './InlineEditTableCell';

/**
 * Generate the table cell callback functions for tables with inline editing
 * @param schemaProp 
 * @param columnValue 
 * @returns Table cell callback functions
 */
export function getInlineEditCell(schemaProp: SchemaProperty, columnValue: string): (item: any) => JSX.Element | undefined {
   
    if (schemaProp.dataType === DataTypes.APPLICATION_SELECT || schemaProp.type === DataTypes.APPLICATION_SELECT) {
        return (item: any) => { 
            if (['string', 'number'].includes(typeof(item))){
                return undefined;
            } else {
                return React.createElement('a', { href: schemaProp.onClickRedirect?.(item) }, item[columnValue]); 
            }
        };
    }

    if (schemaProp.dataType === DataTypes.BOOLEAN || schemaProp.type === 'boolean') {
        return (item: any) => {
            if (['string', 'number', 'boolean'].includes(typeof(item))){
                return undefined;
            } else {
                const content = item[columnValue] ? constants.TRUE : constants.FALSE;
                return React.createElement('div', {className: 'inline-edit-table-cell'},
                    <TableCell displayValue={content} originalValue={item[columnValue]} column={columnValue} schemaProperty={schemaProp} rowItem={item}/>);
            };
        };
    }

    if (schemaProp.UOM === UomTypes.FREQUENCY) {
        return (item: any) => {
            if (['string', 'number'].includes(typeof(item))){
                return undefined;
            } else {
                const content = item[columnValue] ? Number(item[columnValue]).toLocaleString(undefined, { maximumFractionDigits: 2 }) + ' GHz' : '';
                return React.createElement('div', {className: 'inline-edit-table-cell'},
                    <TableCell displayValue={content} originalValue={item[columnValue]} column={columnValue} schemaProperty={schemaProp} rowItem={item}/>);
            };
        };
    }

    if (schemaProp.UOM === UomTypes.STORAGE) {  
        return (item: any) => {
            if (['string', 'number'].includes(typeof(item))){
                return undefined;
            } else {
                const content = item[columnValue] ? Number(item[columnValue]).toLocaleString(undefined, { maximumFractionDigits: 2 }) + ' KB' : '';
                return React.createElement('div', {className: 'inline-edit-table-cell'},
                    <TableCell displayValue={content} originalValue={item[columnValue]} column={columnValue} schemaProperty={schemaProp} rowItem={item}/>);
            };
        };
    }

    if (schemaProp.UOM === UomTypes.PERCENTAGE) {
        return (item: any) => {
            if (['string', 'number'].includes(typeof(item))){
                return undefined;
            } else {
                // Check for type because ternary checks for falsy and 0 fails
                const content = (['string', 'number']).includes(typeof(item[columnValue]))  ?
                    uomConversion(item[columnValue], schemaProp.dbUOM || UOMS.DECIMAL, schemaProp.webUOM || UOMS.PERCENTAGE).toFixed(2) + ' %' : '';
                return React.createElement('div', {className: 'inline-edit-table-cell'},
                    <TableCell displayValue={content} originalValue={item[columnValue]} column={columnValue} schemaProperty={schemaProp} rowItem={item}/>);
            };
        };
    }

    return (item: any) => {
        if (['string', 'number'].includes(typeof(item))){
            return undefined;
        } else {
            return React.createElement('div', {className: 'inline-edit-table-cell'},
                <TableCell 
                    displayValue={item[columnValue] ?? ' '} 
                    originalValue={item[columnValue]} column={columnValue} schemaProperty={schemaProp} rowItem={item}/>);
        };
    };
}

